import React from "react";

import { Grid } from "@material-ui/core";

import { LabelToggleButtons } from "./LabelToggleButtons";
import { withNamespace } from "./lib";
import { SelectField } from "./Select";
import { SelectFieldOption } from "./types";

interface QuickMultiOptionsWithSelectProps {
  options: SelectFieldOption[];
  label: string;
  name: string;
  ns?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Select value type varies
  onChangeExtra?: (value: any) => void;
  disabled?: boolean;
  tooltip?: string;
  missingMLAFieldsWarningEnabled?: boolean;
  overrideMissingFieldName?: string | null;
  required?: boolean;
  placeholder?: string;
  maxMenuHeight?: number;
  maxQuickSelect?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Custom select component props
  SelectComponent?: React.ComponentType<any>;
  // Additional props passed through to the Select component
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Dynamic select props
  selectProps?: Record<string, any>;
}

//  Similar to QuickOptionsWithSelect but supports multiple selection.
export const QuickMultiOptionsWithSelect: React.FC<
  QuickMultiOptionsWithSelectProps
> = ({
  options,
  label,
  name,
  ns = undefined,
  onChangeExtra = undefined,
  disabled,
  tooltip,
  missingMLAFieldsWarningEnabled = false,
  overrideMissingFieldName = null,
  required,
  placeholder = undefined,
  maxMenuHeight = undefined,
  maxQuickSelect = 8,
  SelectComponent = SelectField,
  // Additional props passed through to the Select component
  selectProps = {},
}) => {
  const fieldName = withNamespace(ns, name);

  const quickOptions = React.useMemo(
    () =>
      options
        .slice(0, maxQuickSelect)
        .map(o => ({ value: o.value, label: o.label })),
    [options, maxQuickSelect],
  );

  return (
    <>
      {quickOptions.length > 0 && (
        <Grid item xs={12} style={{ marginBottom: 8 }}>
          <LabelToggleButtons
            label={label}
            name={fieldName}
            options={quickOptions}
            tooltip={tooltip}
            disabled={disabled}
          />
        </Grid>
      )}

      <Grid data-tour={label?.toLowerCase?.()} item xs={12} sm={12}>
        <SelectComponent
          label={quickOptions.length === 0 ? label : ""}
          name={fieldName}
          options={options}
          isClearable
          isMulti
          onChangeExtra={onChangeExtra}
          disabled={disabled}
          required={required}
          placeholder={placeholder}
          maxMenuHeight={maxMenuHeight}
          missingMLAFieldsWarningEnabled={missingMLAFieldsWarningEnabled}
          overrideMissingFieldName={overrideMissingFieldName}
          {...selectProps}
        />
      </Grid>
    </>
  );
};
